import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import cmsActions from 'redux/cmsActions';
import XtraConfirmationDialog from 'utils/xtra-popups/components/XtraConfirmationDialog';
import cmsSelectors from 'redux/cmsSelectors';
import { Popup } from 'utils/xtra-popups/popup';
import {
  CONFIRMATION_DIALOG_POPUP_KEY,
  ConfirmationDialogData,
} from 'utils/xtra-popups/popupsTypes/confirmationDialogData';

const XtraConfirmationDialogPopups: FC = () => {
  const popups = useSelector(cmsSelectors.popups.selectPopupsByType(CONFIRMATION_DIALOG_POPUP_KEY)) as Popup<ConfirmationDialogData>[];
  return (
    <>
      {popups.map((popup) => <XtraConfirmationDialog popup={popup} key={popup.id} />)}
    </>
  );
};

export default XtraConfirmationDialogPopups;
